import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";
import CompanyHrmsSetupModal from "./hrms_setup_modal";
import { ArrowRight, Pen, Trash } from "lucide-react";

const MASTER_TYPES = [
  "Leave Type",
  "Pay Slip Type",
  "Allowance Option",
  "Loan Option",
  "Deduction Option",
  "Goal Type",
  "Training Type",
  "Award Type",
  "Termination Type",
  "Performance Type",
];

const CompanyHrmsSetup = () => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedType, setSelectedType] = useState(MASTER_TYPES[0]);

  const company_id = localStorage.getItem("companyID");

  const fetchList = async (type) => {
    try {
      const res = await axios.get(
        `${API_URL}/company-hrmd-system-setup/${company_id}?master_type=${type}`
      );
      setList(res.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchList(selectedType);
  }, [selectedType]);

  const handleAdd = () => {
    setEditData({
      master_type: selectedType,
    });
    setShowModal(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This setup will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${API_URL}/company-hrmd-system-setup/${id}`);
      Swal.fire({
        toast: true,
        position: "top-end", // top-right corner
        icon: "success",
        title: "HRMS setup deleted successfully",
        showConfirmButton: false,
        timer: 2000, // disappears in 2 seconds
        timerProgressBar: true,
      });
      fetchList(selectedType);
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to delete HRMS setup",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    }
  };


  return (
    <div className="row" style={{ marginTop: "60px" }}>
      {/* LEFT MASTER TYPE LIST */}
      <div className="col-md-3">
        <ul className="nav flex-column nav-pills tab-style-7">
          {MASTER_TYPES.map((type) => (
            <li
              key={type}
              className={`nav-link text-start mb-2 d-flex justify-content-between ${selectedType === type ? "active" : ""
                }`}
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedType(type)}
            >
              <span>{type}</span><span><ArrowRight size={16} /></span>
            </li>
          ))}
        </ul>
      </div>

      {/* RIGHT CONTENT */}
      <div className="col-md-9">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">{selectedType}</h5>
            <button className="btn btn-primary" onClick={handleAdd}>
              + Add {selectedType}
            </button>
          </div>

          <div className="card-body">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  {selectedType == 'Leave Type' && <th>Days per year</th>}
                  <th width="150">Actions</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((row) => (
                    <tr key={row.id}>
                      <td>{row.name}</td>
                      {selectedType == 'Leave Type' && <td>{row.values || "-"}</td>}
                      <td>
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() => handleEdit(row)}
                        >
                          <Pen />
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(row.id)}
                        >
                          <Trash />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {showModal && (
            <CompanyHrmsSetupModal
              show={showModal}
              heading={editData?.id ? "Edit Setup" : "Add Setup"}
              initialData={editData}
              onClose={() => setShowModal(false)}
              onSuccess={() => fetchList(selectedType)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyHrmsSetup;
